import React, { useMemo } from 'react';
import { ArrowRight, CalendarDays } from 'lucide-react';
import { Link } from 'react-router-dom';
import { allEvents, sortEvents } from '../utils/events';
import EventCard from './EventCard';

const EventsSection: React.FC = () => {
  const { upcomingEvents } = useMemo(() => sortEvents(allEvents), []);
  const featuredEvents = upcomingEvents.slice(0, 2);

  return (
    <section id="events" className="bg-white py-20">
      <div className="page-container">
        <div className="mb-9 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="eyebrow">Meet, learn, celebrate</p>
            <h2 className="section-title">Upcoming Events</h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-[#667085]">
              Join neighbors and friends for Japanese cultural programs across Northeast Florida.
            </p>
          </div>
          <Link to="/events" className="btn-secondary self-start sm:self-auto">
            View all events
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        {featuredEvents.length > 0 ? (
          <div className="grid gap-5 lg:grid-cols-2">
            {featuredEvents.map((event) => <EventCard key={event.id} event={event} isUpcoming />)}
          </div>
        ) : (
          <div className="surface flex min-h-52 flex-col items-center justify-center px-6 text-center">
            <CalendarDays className="h-8 w-8 text-[#d95f75]" />
            <p className="mt-4 font-bold text-[#172033]">More community events are coming soon.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default EventsSection;
